import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'


// 当前各服dau
const serverDau = obj => new Promise((resolve, reject) => {
    const {
        token,
        loginUriForm
    } = obj;
    request({
        url: apis.server_dau+ '?token=' + token,
        data: loginUriForm
    }).then(res => {
        resolve(res);
    })
})

// 分服充值  分服dau数据
const getAllDauRecords = obj => new Promise((resolve, reject) => {
    const {
        token,
        recordsForm
    } = obj;
    request({
        url: apis.get_all_dau_records+ '?token=' + token,
        data: recordsForm
    }).then(res => {
        resolve(res);
    })
})

export default {
    serverDau,
    getAllDauRecords
}



// WEBPACK FOOTER //
// ./src/service/dau_api.js